import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { pega_alunos_planos } from "../../services/api";

const Alunos_planos = (props) => {

    const [data2, setData2] = useState([]);
    const [dataR, setDataR] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio']

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await pega_alunos_planos(data_inicio, data_fim);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("data2", data2);

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);


    let chartDataPL = [];
    let total = 0;
    let totalA = 0;
    let totalB = 0;
    let totalC = 0;
    let totalD = 0;

    if (typeof data2 !== 'undefined') {


        chartDataPL = data2.map((item, index) => {
            const row = [unidades[parseInt(item.sec)]];
            row.push(item.dsc);
            row.push(parseInt(item.alunos) || 0);
            total += parseInt(item.alunos) || 0;
            totalA += (item.dsc === 'Plano A' ? parseInt(item.alunos) || 0 : 0);
            totalB += (item.dsc === 'Plano B' ? parseInt(item.alunos) || 0 : 0);
            totalC += (item.dsc === 'Plano C' ? parseInt(item.alunos) || 0 : 0);
            totalD += (item.dsc === 'Plano D' ? parseInt(item.alunos) || 0 : 0);
            return row;
        });
    };

    chartDataPL.sort()
    chartDataPL.unshift(['Unidade', 'Plano', 'Alunos']);
    chartDataPL.push(['Total', 'REDE', total]);
    chartDataPL.push(['Total', 'Plano A', totalA]);
    chartDataPL.push(['Total', 'Plano B', totalB]);
    chartDataPL.push(['Total', 'Plano C', totalC]);
    chartDataPL.push(['Total', 'Plano D', totalD]);

    console.log('chartDataPL', chartDataPL)

    const options = {
        allowHtml: true,
        pageSize: 15,

    };

    // let formatters = [
    //     {
    //         type: "NumberFormat",
    //         column: 1,
    //         options: {
    //             prefix: "R$",
    //             negativeColor: "red",
    //             negativeParens: true,
    //         },
    //     },
    //     {
    //         type: "NumberFormat",
    //         column: 2,
    //         options: {
    //             prefix: "R$",
    //             negativeColor: "red",
    //             negativeParens: true,
    //         },
    //     },
    //     {
    //         type: "NumberFormat",
    //         column: 3,
    //         options: {
    //             suffix: " %",
    //             negativeColor: "red",
    //             negativeParens: true,
    //         },
    //     },
    //     {
    //         type: "ColorFormat",
    //         column: 3,
    //         ranges: [
    //             [-10000, 0, "white", "red"],
    //             [0, 1, "white", "orange"],
    //             [1, 3, "white", "blue"],
    //             [3, 10000, "white", "green"],
    //         ],
    //     },
    // ];

    return (
        <div className="media">
            <h2>
                Alunos por Planos

            </h2>
            <Chart
                chartType="Table"
                width="100%"
                version="current"

                data={chartDataPL}
                options={options}
                // formatters={formatters}
                chartWrapperParams={{ view: { columns: [0, 1, 2] } }}
                chartPackages={["corechart", "controls"]}
                controls={[
                    {
                        controlEvents: [
                            {
                                eventName: "statechange",
                                callback: ({ chartWrapper, controlWrapper }) => {
                                    console.log("State changed to", controlWrapper?.getState());
                                },
                            },
                        ],
                        controlType: "CategoryFilter",
                        options: {
                            filterColumnIndex: 1,
                            ui: {
                                labelStacking: "vertical",
                                label: "Plano",
                                allowTyping: false,
                                allowMultiple: false,
                            },
                        },
                    },
                ]}
            />
        </div>
    );
};
export default Alunos_planos;